import { mq, Skeleton as _Skeleton } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

// ItemEpisodeSkeleton用のstyle
export const DivFlexContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`;

export const DivItemEpisodeSkeletonWrapper = styled.div<{
  oneItemWidthRatio: number;
  itemHeight: number;
  padding?: string;
}>`
  display: flex;
  width: ${({ oneItemWidthRatio }) => oneItemWidthRatio}%;
  height: ${({ itemHeight }) => itemHeight}px;
  padding: ${({ padding }) => padding ?? "0px"};
`;

export const ItemEpisodeSkeletonImg = styled(_Skeleton)`
  margin-right: 16px;
  border-radius: 8px;

  ${mq.sp} {
    margin-right: 8px;
  }
`;

export const DivSkeletonDescriptionWrapper = styled.div`
  flex: 1;
`;

export const ItemEpisodeDetailSkeleton = styled(_Skeleton)`
  max-height: 24px;

  :not(:first-of-type) {
    margin-top: 8px;
  }

  ${mq.sp} {
    max-height: 16px;
  }
`;
